<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Текущий статус</div>
            <div class="dx-field-value">
                <div class="flex flex-row">
                    <div class="w-[55%]"><div :class="textcolor">{{value}}</div></div>
                    <div class="w-[45%]"><dx-button @click="onButtonClick">Изменить статус</dx-button></div>
                </div>
                <dx-popup
                    :visible="popupVisible"
                    :show-close-button="true"
                    :key="componentKey"
                    width="300px"
                    height="150px"
                    title="Изменение статуса"
                    @hidden="onHidden"
                >
                    <div class="h-full flex flex-col justify-between items-center">
                            <dx-button v-if="showButton2" class="w-[80%]" text="Новый" @click="onSelectStatusNew" />
                            <dx-button v-if="showButton0" class="w-[80%]" text="Активный" @click="onSelectStatusActive" />
                            <dx-button v-if="showButton1" class="w-[80%]" text="Архивный" @click="onSelectStatusDeleted" />
                    </div>
                </dx-popup>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, inject, ref } from 'vue';
//import AiTextBox from '@/components/ai-text-box.vue';
import { DxButton, DxPopup } from 'devextreme-vue';

//const serverData = inject('serverData');
const userData = inject('userData');

const popupVisible = ref(false);
const componentKey = ref(0);

const value = computed(() => {
    if (userData.value['pr_active'] === undefined) {
        return null;
    }
    return userData.value['active_name'];
});

const showButton = (prActive) => {
    return userData.value['pr_active'] !== prActive;
};

const showButton0 = computed(() => {
    return showButton(0);
});

const showButton1 = computed(() => {
    return showButton(1);
});

const showButton2 = computed(() => {
    return showButton(2);
});

const textcolor = computed(() => {
    if (userData.value['pr_active'] === 0)
    {
        return 'dx-status-active';
    }
    else if (userData.value['pr_active'] === 1)
    {
        return 'dx-status-archive';
    }
    else if (userData.value['pr_active'] === 2)
    {
        return 'dx-status-new';
    }
    else {
        return 'dx-status-undefined';
    }
});

const onButtonClick = () => {
    popupVisible.value = true;
};

const onSelectStatusNew = () => {
    popupVisible.value = false;
    userData.value['pr_active'] = 2;
    userData.value['active_name'] = 'Новый';
    componentKey.value += 1;
};

const onSelectStatusActive = () => {
    popupVisible.value = false;
    userData.value['pr_active'] = 0;
    userData.value['active_name'] = 'Активный';
    componentKey.value += 1;
};

const onSelectStatusDeleted = () => {
    popupVisible.value = false;
    userData.value['pr_active'] = 1;
    userData.value['active_name'] = 'Архивный';
    componentKey.value += 1;
};

const onHidden = () => {
    popupVisible.value = false;
};
</script>
<style>

.dx-status-undefined{
    color: black;
    font-size: 16px;
    font-weight: bold;
}

.dx-status-active{
    color: royalblue;
    font-size: 16px;
    font-weight: bold;
}

.dx-status-archive{
    color : firebrick;
    font-size: 16px;
    font-weight: bold;
}

.dx-status-new{
    color : green;
    font-size: 16px;
    font-weight: bold;
}


</style>
